import { combineReducers } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import plansSlice from './slices/plansSlice'
import addProductsSlice from './slices/addProductsSlice'
import feedbackSlice from './slices/feedbackSlice'
import filesSlice from './slices/filesSlice'
import claimOrReleaseProductsSlice from './slices/claimOrReleaseProductsSlice'
import navBarSlice from './slices/navBarSlice'
import requestVendorPreIsuSlice from './slices/requestVendorPreIsuSlice'
import rollupSlice from './slices/rollupSlice'
import associateProductsSlice from './slices/associateProductsSlice'
import settingsSlice from './slices/settingsSlice'
import greenfieldSlice from './slices/greenfieldSlice'
import vendorsSlice from './slices/vendorsSlice'
import attributeValuesSlice from './slices/attributeValuesSlice'
import eventsSlice from './slices/eventsSlice'
import productsSlice from './slices/productsSlice'

export const appReducer = combineReducers({
  auth: authSlice,
  events: eventsSlice,
  vendors: vendorsSlice,
  feedback: feedbackSlice,
  products: productsSlice,
  files: filesSlice,
  attributeValues: attributeValuesSlice,
  claimOrReleaseProducts: claimOrReleaseProductsSlice,
  allPlans: plansSlice,
  navBar: navBarSlice,
  requestVendorPreIsu: requestVendorPreIsuSlice,
  rollup: rollupSlice,
  associateProducts: associateProductsSlice,
  addProducts: addProductsSlice,
  settings: settingsSlice,
  greenfield: greenfieldSlice,
})

export const rootReducer = (state, action) => {
  // when a reset_store action is dispatched it will reset redux state
  if (action.type === 'RESET_STORE') {
    state = undefined
  }

  return appReducer(state, action)
}
